import { log } from '@/helpers/utils';
import useApi, { getModelFromViewCode } from '../api';


export async function submitPlayerRegistration(
  locationUid: any,
  registrationCode: any,
  options: any
) {
  const { post } = useApi();
  
  const { responseBody } = await post(
    `api/players/${registrationCode}/register?locationUid=${locationUid}`,
    options,
    {isLogoutOnInvalidAuth: true}
  );
  const responseData = responseBody;
  return responseData;
}
export async function reassignPlayer (playerId: any , registrationCode : any  ) {
  const { post } = useApi();
  
  const { responseBody } = await post(`api/players/${playerId}/reassign?newPlayerRegCode=${registrationCode}`,null, {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}
export async function getPlayerById (playerId: string ) {
  const { get } = useApi();
  
  const { responseBody } = await get(`api/players/${playerId}`, {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}

export async function updatePlayer (playerId: string , options : any  ) {
  const { put } = useApi();
  
  const { responseBody } = await put(`api/players/${playerId}`,[options], {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}
export async function addPlayerMetadata (playerId: string , options : any  ) {
  const { post } = useApi();
  
  const { responseBody } = await post(`api/Players/${playerId}/metadatas`,[options], {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}
export async function deleteMetadata (tagId: number   ) {
  const { deleteRequest } = useApi();
  
  const { responseBody } = await deleteRequest(`api/metadatas/${tagId}`, {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}

export async function deleteMetadataForAllPlayers(category:string,value:string) {
  const { post } = useApi();
  
  const { responseBody } = await post(`api/metadatas/DeleteForAllPlayers`,{
    category,
    value
  }, {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}

export async function previewPlayer (playerId : number ) {
  const { post } = useApi();
  
  const { responseBody } = await post(`api/players/${playerId}/preview`,null, {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}
export async function previewPlayerByDate (playerId :string, date :any ){
  const { post } = useApi();
  
  const { responseBody } = await post(`api/players/${playerId}/preview?month=${date.month}&day=${date.day}&year=${date.year}&hours=${date.hour}&minutes=${date.minute}`,null, {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}
export async function searchUptime (playerId :string, days :any ){

  const { post } = useApi();
  
  const { responseBody } = await post(`api/players/${playerId}/uptime?daysAgo=${days}`,null, {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}
export async function searchMetaData (playerId :string){

  const { post } = useApi();
  
  const { responseBody } = await post(`api/players/AutoComplete/${playerId}`,null, {isLogoutOnInvalidAuth: true});
  const responseData = responseBody;
  return responseData;
}
// http://htopology-002-site2.etempurl.com/api/players/AutoComplete/755989


export async function getAllMetadatas() {
  const { get } = useApi();
  const { responseBody } = await get(`api/metadatas/AutoComplete`, {isLogoutOnInvalidAuth: true});
  return responseBody;
}

// Helper to strip hyphens from UUID (database stores UUIDs without hyphens)
const stripUuidHyphens = (uuid: string): string => {
  return uuid.replace(/-/g, '');
};

export async function getPlayersByDeviceUuids(deviceUuids: string[]): Promise<Array<{ name: string; id: number; deviceUuid?: string }>> {
  const { get, post } = useApi();
  
  // Backend route: Api/Players/DeviceUuids (controller: Players, action: GetByDeviceUuids)
  const endpoint = 'Api/Players/DeviceUuids';
  
  // Strip hyphens from UUIDs before sending to API (database stores UUIDs without hyphens)
  // Metrics table has UUIDs with hyphens, but main DSP database has them without hyphens
  const uuidsWithoutHyphens = deviceUuids.map(stripUuidHyphens);
  
  try {
    // Try POST first (preferred method for batch requests)
    const { responseBody } = await post(
      endpoint,
      { deviceUuids: uuidsWithoutHyphens },
      { isLogoutOnInvalidAuth: true }
    );
    
    // The endpoint returns an array of players
    return Array.isArray(responseBody) ? responseBody : [];
  } catch (err: any) {
    // If POST fails with 404, try GET with query params as fallback
    if (err?.response?.status === 404) {
      const { responseBody } = await get(
        endpoint,
        {
          params: {
            uids: uuidsWithoutHyphens.join(',')
          },
          isLogoutOnInvalidAuth: true
        }
      );
      
      return Array.isArray(responseBody) ? responseBody : [];
    }
    throw err;
  }
}